import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextStandardTeaser from '@contexts/standardTeaser'
import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

type StyledTextWrapperProps = Pick<
  StandardTeaserLayoutContextType,
  'hasVideoOnlyStyle' | 'isInMegaModule'
>

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledTextWrapper = styled.div<StyledTextWrapperProps>`
  ${({
    theme: {
      colors: {
        blicktvGrey: { btvGrey_60 },
      },
    },
    hasVideoOnlyStyle,
    isInMegaModule,
  }) => {
    let notMobileCSS
    if (hasVideoOnlyStyle) {
      notMobileCSS = css`
        padding: ${isInMegaModule ? '6px 6px 6px 10px' : '5px 6px 5px 6px'};
      `
    } else {
      notMobileCSS = css`
        padding: 5px 0 0 0;
        padding: ${isInMegaModule ? '0px 6px 6px 10px' : '5px 0 0 0'};
      `
    }

    let mobileStyle
    if (hasVideoOnlyStyle) {
      mobileStyle = css`
        padding: 6px 6px 6px 10px;
      `
    } else {
      mobileStyle = css`
        padding: 0 6px 0 10px;
      `
    }

    return css`
      min-width: 0;
      width: 100%;
      box-sizing: border-box;
      ${hasVideoOnlyStyle && `background-color: ${btvGrey_60}`};

      ${desktopCSS(css`
        ${notMobileCSS}
      `)}

      ${tabletCSS(css`
        ${notMobileCSS}
      `)}

      ${mobileCSS(css`
        ${mobileStyle}
      `)}
    `
  }}
`

const TextWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { hasVideoOnlyStyle, isInMegaModule } = useContext(
    StandardTeaserLayoutContext
  )

  return (
    <StyledTextWrapper
      hasVideoOnlyStyle={hasVideoOnlyStyle}
      isInMegaModule={isInMegaModule}>
      {children}
    </StyledTextWrapper>
  )
}

export default TextWrapper
